import { ff } from '@atlassian/jira-feature-flagging';

// <wviveiro>
export const ISSUE_DETAILS_SORTING_PINNED_FIELDS = 'issue.details.sorting-pinned-fields' as const;
export const isSortingPinnedFieldsEnabled = () => ff('issue.details.sorting-pinned-fields', false);
// </wviveiro>
